import { Component, Input } from '@angular/core';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'checkout-test-mode',
  templateUrl: './test-mode.component.html',
  styleUrls: ['./test-mode.component.scss'],
  standalone: false,
})
export class TestModeComponent {
  @Input() settings: CheckoutSettings;
  @Input() formGroup: UntypedFormGroup;
  constructor() {}
}
